import { Component, OnInit, OnDestroy } from '@angular/core';

import { HsgSubNavService } from '@hhsg/hsg-asc';
import { PageLayoutService } from 'src/shared/services/page-layout.service';

@Component({
  selector: 'smt-workflow',
  templateUrl: './workflow.component.html',
  styleUrls: ['./workflow.component.scss']
})
export class WorkflowComponent implements OnInit {

  constructor(
    private _subNav: HsgSubNavService,
    private _layout: PageLayoutService) { }

  ngOnInit() {
    this._layout.setLayoutStyle('workflow');
    // Workaround for shared components bug that requires us to reset SubNav
    this._subNav.setSubNavData({
        title: "",
        links: [] 
    });
  }

  ngOnDestroy(){
    this._layout.clearLayoutStyle();
  }
}
